import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CalculateBoxField } from '../../../../form-field/calculatebox-field';
import { LayoutService } from '../../../../../services/layout/layout.service';
import { Parser } from 'expr-eval';
import { SharedSettingsService } from '../../../../../services/settings/settings-base.service';
import { CurrencyFormatPipe } from '../../../../pipes/currency-format.pipe';
import { LoggingService } from '../../../../core/app-insights/logging.service';
import { GlobalFunctionService } from '../../../../../services/globalfunction/globalfunction.service';
@Component({
  selector: 'lib-calculation-box',
  templateUrl: './calculation-box.component.html',
  styleUrls: ['./calculation-box.component.scss']
})

export class CalculationBoxComponent implements OnInit {
  public isSmallView: boolean;
  public mandatoryErrorMessage: any;
  public inputMissingErrorMessage: string;
  @Input() field: CalculateBoxField;
  @Input() form: FormGroup;
  constructor(
    private layoutService: LayoutService,
    private sharedSettingsService: SharedSettingsService,
    private currencyPipe: CurrencyFormatPipe,
    private loggingService: LoggingService,
    private globalFunctionService: GlobalFunctionService
  ) { }
  checkViewPortWidth() {
    this.layoutService.subscribeToLayoutChanges().subscribe(observerResponse => {
      this.isSmallView = this.layoutService.isSmallView();
    });
  }
  ngOnInit() {
    this.mandatoryErrorMessage = this.field?.mandatoryValidationMsg || 'This field is required';
    if (this.field.label === undefined || this.field.label === null) {
      this.field.label = '';
    }
    this.calculateValueUsingGlobalFunction(this.field);
    this.subscribeOnInputValueChange();
  }
  get formControl(): any {
    return this.form.controls[this.field.key];
  }
  getSpecificErrorMessage() {
    if (this.formControl.hasError('required')) {
      return this.mandatoryErrorMessage;
    }  
}
  subscribeOnInputValueChange() {
  if (this.field.inputParams && this.field.inputParams.length > 0) {
    for (const key of this.field.inputParams) {
      const control = this.form.get(key);
      if (control) {
        // Subscribe to valueChanges for each inputParams key
        control.valueChanges.subscribe((value: any) => {
          // Update the inputParams with the new value
          if (this.field.globalFunction)
            // Call the global function to recalculate the value
           {this.calculateValueUsingGlobalFunction(this.field);}
        });
      }
      }
    }
  }

  calculateValueUsingGlobalFunction(formfield: CalculateBoxField) {
    if (formfield.globalFunction === undefined || formfield.globalFunction === null || formfield.globalFunction === '') {
      return;
    }
    // Parse the global function to extract the expression and check for math functions
    const parsedFunction = this.parseGlobalFunction(formfield.globalFunction);
    const resexpression = parsedFunction.expression; 
    if (parsedFunction.hasApiFunction) {
      // If the global function is an API function, call the API
      this.globalFunctionService.getUsingGlobalFunctionAPIMethod(formfield.globalFunction, this.field.value).subscribe({
        next: (response: string) => {
          formfield.value = response;
            this.assignValueToField(formfield);
        }
      });
    }
    else if (resexpression !== undefined && resexpression !== null && resexpression !== '') {
      formfield.value = this.getUsingCalculateCondition(resexpression, parsedFunction.hasMathFunction, formfield.calculationInput);      
    }
      this.assignValueToField(formfield);
}
  assignValueToField(formfield: CalculateBoxField) {
  this.field.value = formfield.value;
  if (this.field.value !== undefined && this.field.value !== null && this.field.value !== '') {     
       if (this.formControl !== undefined && this.formControl !== null) {    
        this.formControl.clearValidators();
        // convert the value to localized format using currency pipe if its a number
        const localizedFormat = this.currencyPipe.transform(this.field.value)
        this.formControl.setValue(localizedFormat);
        if (this.field.calculationInput) {
          this.formControl.updateValueAndValidity({ onlySelf: true, emitEvent: true });
        } else {
          this.formControl.updateValueAndValidity({ onlySelf: true, emitEvent: false });
        }        
       }
     }
}
  getUsingCalculateCondition(resexpression: string, hasMathFunction: boolean = false, isCalculationInput: boolean = false): string {
    let result: any;
    try {
        const parser = new Parser();
        const evaluate = parser.parse(resexpression);
        const variable = evaluate.variables();
        // Find all CalculationInput fields
        const context = this.getVariablesValuesDetails(variable, hasMathFunction, isCalculationInput);
        if (context && Object.keys(context).length !== 0) {
          this.field.inputParams = Object.keys(context);
          result = evaluate.evaluate(context);
        }
    } catch (error) {
      this.loggingService.logException(error);
      }
    return result;
    }
  // Find all CalculationInput fields
  getVariablesValuesDetails( variables: string[], hasMathFunction: boolean, isCalculationInput: boolean): any {
  const context: Record<string, any> = {};
  for (const field of variables) { 
    const fieldValue = this.form.get(field)?.value;
    if (fieldValue === undefined && !isCalculationInput) {
      this.inputMissingErrorMessage = 'Missing Required Field:' + field;
      return;
    }
    const filedValueToCalculate =  hasMathFunction ? this.getValueNumberValue(fieldValue) : fieldValue;   
    context[field] = filedValueToCalculate === undefined ? '' : filedValueToCalculate;
  }
  return context;
}
  getValueNumberValue(value: any): number {
 if (value === undefined || value === null || value === '') {
    return 0;
  }
 return isNaN(value) ? this.sharedSettingsService.reverseFormatNumber(value) : value;
}
  parseGlobalFunction(globalFunction: string):  {expression: string, hasMathFunction: boolean, hasApiFunction: boolean} {
  let resexpression: string;
  let hasmathfunction: boolean = false;
  let hasapifunction: boolean = false;
  if (globalFunction.startsWith('Math')) {
    resexpression = globalFunction.trim().replace(/^math\((.+)\)$/i, '$1'); 
    hasmathfunction = true;
  }
  else if (globalFunction.startsWith('Condition')) {
    resexpression = globalFunction.replace('Condition', '');    
    const mathOperationReges = /[+\-*/%]/;
    hasmathfunction = mathOperationReges.test(globalFunction);
  }
  else {
    resexpression = globalFunction;
    hasapifunction = true;

  }
  return { expression: resexpression, hasMathFunction: hasmathfunction, hasApiFunction: hasapifunction };
}
}
